
import { Core } from '@pdftron/webviewer';
import { Rectangle } from '../../interfaces';

export class PageElement {
    element: Element | Core.Annotations.Annotation;

    get textContent(): string | null {
        throw new Error('Not implemented.');
    }

    set textContent(_: string | null) {
        throw new Error('Not implemented.');
    }

    get boundary(): Rectangle | null {
        throw new Error('Not implemented.');
    }

    constructor(element: Element | Core.Annotations.Annotation) {
        this.element = element;
    }
}
